import React from 'react';
import { Bug } from 'lucide-react';
import { openDevPanel } from '@/stores/devPanelStore';

// Embedded, Layout hides the NavigationBar that holds the only other opener. Dev-gated rather
// than admin.dev-panel: that needs a resolved profile, and the auth-failure screen has none.
const EmbeddedDevPanelTrigger: React.FC = () => {
  if (!import.meta.env.DEV) return null;

  return (
    <button
      type="button"
      onClick={openDevPanel}
      title="Dev Panel"
      className="fixed bottom-3 right-3 z-[150] flex h-7 w-7 items-center justify-center rounded-md border border-border/60 bg-background/80 text-muted-foreground opacity-40 shadow-sm backdrop-blur transition-opacity hover:opacity-100"
    >
      <Bug size={13} />
      <span className="sr-only">Dev Panel</span>
    </button>
  );
};

export default EmbeddedDevPanelTrigger;
